import React from "react";
import { Modal } from "react-bootstrap";

const MobileActionModal = ({ show, onHide, actions }) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      size="sm"
      className="inventory-action-modal"
    >
      <Modal.Body className="p-0">
        {actions.map((action, idx) => (
          <div
            key={idx}
            role="button"
            className="d-flex align-items-center gap-3 px-4 py-3"
            style={{
              fontSize: 15,
              borderBottom: idx < actions.length - 1 ? "1px solid #dee2e6" : "none",
              color: action.color || "inherit",
            }}
            onClick={() => {
              action.onClick();
              onHide();
            }}
          >
            {action.icon && <img src={action.icon} alt={action.label} width={18} height={18} />}
            <span>{action.label}</span>
          </div>
        ))}
      </Modal.Body>
    </Modal>
  );
};

export default MobileActionModal;
